// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card .content .card-row .card-row-element .description.disbursement-date{display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = exports;
